import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const badges = ['800+ Pages of Proven Systems', '1,000+ Ready-to-Use Prompts', 'Used by Top Agents in 4 Countries'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-900" data-id="element-50" data-mp="4lyswf6y22ah">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[radial-gradient(1200px_600px_at_15%_-10%,#234A66_0%,transparent_60%),radial-gradient(900px_500px_at_100%_100%,#153044_0%,transparent_55%)]" data-id="element-51" data-mp="4jm7tt5w3bt7" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 grid-pattern opacity-40" data-id="element-52" data-mp="sb1chsl5257m" />

      <div className="relative mx-auto max-w-5xl px-5 pb-3 pt-3 sm:px-6 lg:max-w-6xl lg:px-8 lg:pb-20 lg:pt-14" data-id="element-53" data-mp="ncq1hej3xont">
        <motion.div className="lg:grid lg:grid-cols-[1.08fr_0.92fr] lg:items-center lg:gap-x-14" initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-54" data-mp="3d1sakxd0hjt4">
          <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-55" data-mp="3o85cdefo0765">
            <p className="mb-6 inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-[11px] text-xs font-extrabold text-slate-200 sm:w-auto sm:px-16 lg:mb-5 lg:px-6" style={{
            marginTop: "0px"
          }} data-id="element-56" data-mp="3o59bpicfn4e0">
              <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-brand-gold" data-id="element-57" data-mp="30ggab6d1k4c0" />
              KODA DIGITAL
            </p>

            <h1 className="text-[24px] font-extrabold text-white" data-id="element-58" data-mp="2qjv7mrohv5bc">
              <span className="block text-[26px] leading-[1.15] tracking-tight sm:text-4xl lg:text-[44px] lg:leading-[1.08]" data-id="element-59" data-mp="2qlelycqlb6ah">
                THE TRADITIONAL AGENT IS DYING. <span className="text-brand-gold" data-id="element-60" data-mp="2hind8kp3momj">THE AI-POWERED ARCHITECT IS TAKING THE MARKET.</span>
              </span>
              <span className="block w-full max-w-[328px] text-base font-medium leading-relaxed text-slate-300 sm:text-lg lg:mt-5 lg:max-w-xl" data-id="element-61" data-mp="2ljgyt7f2jrc9">
                The rules of Real Estate just changed forever. You are either the one using the engine, or the one being crushed by it.
              </span>
            </h1>
          </div>

          <motion.figure className="relative mt-8 sm:mt-10 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0 lg:self-center" initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-62" data-mp="ia5kl1vkqpwa">
            <div className="mx-auto w-full max-w-[420px] overflow-hidden rounded-2xl border border-white/10 shadow-2xl ring-1 ring-brand-gold/20 sm:max-w-[460px] lg:max-w-none" data-id="element-63" data-mp="111erd3dyn0k6">
              <img src="https://cdn.magicpatterns.com/uploads/bS9CBFjnd5mFrWa2H7s2Tq/comprimido-1x1.jpg" alt="Real estate agent on a luxury balcony with AI data visualizations mapping a modern property" className="h-[301px] w-full object-cover object-[30%_center] sm:aspect-square sm:h-auto sm:object-center" width={1024} height={1024} loading="eager" data-id="element-64" data-mp="3lt756pxsnptq" />
            </div>
          </motion.figure>

          <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-65" data-mp="269r41x2fzkb3">
            <p className="text-base leading-relaxed text-slate-300 sm:text-center sm:text-lg lg:mt-8 lg:text-left" data-id="element-66" data-mp="2b0pnv6mn30j3">
              The 800+ page system that turns real estate agents into autonomous, deal-closing machines — built for
              the market you are actually selling in today.
            </p>

            <div className="flex flex-col items-stretch gap-3 sm:items-center lg:mt-7 lg:items-start" data-id="element-67" data-mp="2p0qpwpen4e05">
              <CTAButton href="#offer" className="w-full sm:w-auto" data-id="element-68" data-mp="2u03lbyjkutec">
                <span className="block text-[20px]" data-id="element-69" data-mp="2tx7o6cfk08qy">Discover what&rsquo;s inside</span>
                <span className="block text-[20px]" data-id="element-70" data-mp="uokcdjy9xl4o">See the complete system</span>
              </CTAButton>
              <p className="text-center text-[12px] text-slate-400 lg:text-left" data-id="element-71" data-mp="znn9mi80in23">
                Join <span className="font-semibold text-slate-200" data-id="element-72" data-mp="49je886ectnp">2,000+ agents</span> who&rsquo;ve already
                transformed their business.
              </p>

              <p className="flex items-center justify-center gap-1.5 text-center text-[12px] leading-tight text-slate-300 lg:justify-start lg:text-left" data-id="element-73" data-mp="e8iofv6t8xct">
                <span data-id="element-74" data-mp="3hqa90oimaf0z">
                  <span className="font-semibold text-white" data-id="element-75" data-mp="3hpr3k7a5lj3u">🌍 Global Edition:</span> Fully compatible with all
                  international real estate markets.
                </span>
              </p>

              <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 pb-4 lg:justify-start lg:pb-0" data-id="element-76" data-mp="3rgby9jmpi3hh">
                {badges.map(badge => <li key={badge} className="flex items-center gap-1.5 text-[13px] font-semibold leading-tight text-slate-200" data-id="element-77" data-mp="3mnafv1najlt5">
                    <CheckIcon aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-brand-gold" data-id="element-78" data-mp="2u0y25varij1u" />
                    {badge}
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </header>;
}